import { createAsyncActionType } from './index';

export const ACTIVE_MODULES_GET = createAsyncActionType(
  'modules',
  'ACTIVE_MODULES_GET'
);
